module.exports = "https://neera-retreat.sgp1.cdn.digitaloceanspaces.com/assets/about/05_nakhon_Pathom_01.png";